export const getReason = (payload: string) => {
    const reason = extractValue(payload, 'reason')
    if (reason) {
        return reason
    }

    if (payload?.includes('Insufficient')) {
        return 'Insufficient funds'
    }
}

export const extractPaymentReference = (payload: string) => {
    if (!payload) return ''

    const match = /"merchantReference"\s*:\s*"([^"]+)"/.exec(payload)
    return match ? match[1] : ''
}

export const extractValue = (payload: string, value: string): string => {
    if (!payload) return ''

    const match = new RegExp(`"${value}"\\s*:\\s*"([^"]+)"`).exec(payload)
    return match ? match[1] : ''
}
